import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-public-lighting',
    templateUrl: './public-lighting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PublicLightingComponent {

    @Input() serviceId: string;


}
